import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import getDownloadUrlNew from '../../../utils/getDownloadUrlNew';
let AuthorCard = class AuthorCard extends Vue {
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem("token");
    }
    getDownloadUrlNew(refId) {
        return getDownloadUrlNew.getImageUrl(refId);
    }
};
tslib_1.__decorate([
    Prop({ default: {} })
], AuthorCard.prototype, "cardData", void 0);
AuthorCard = tslib_1.__decorate([
    Component({ name: "author-card", components: {} })
], AuthorCard);
export default AuthorCard;
